import React from 'react';
import { CustomCircularProgress } from '@/components/Loading/CustomCircularProgress';

const EditableFieldCell = ({
  statusColor,
  displayValue,
  onClick,
  isLoading,
}) => {
  return (
    <div
      className={`mx-auto border border-solid  ${
        statusColor
          ? ` text-primary-text ${statusColor} hover:opacity-80`
          : 'border-border-tertiary text-gray-600 hover:bg-gray-50'
      } rounded-lg w-16 h-8 flex items-center justify-center px-4  text-xs cursor-pointer  transition-colors`}
      onClick={onClick}>
      {isLoading ? (
        <CustomCircularProgress className="w-4 h-4 border-2" />
      ) : (
        <span>{displayValue}</span>
      )}
    </div>
  );
};

export default EditableFieldCell;
